import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Input, Modal, message } from 'hljd'
import { observer } from 'mobx-react'
import { dGet } from '@core/utils'

const FormItem = Form.Item
const { TextArea } = Input
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 }
}

/**
 * 这个弹窗和日程中的 TaskForm 一样，待统一
 */
@Form.create()
@observer
class ConfirmTaskModal extends Component {
  handleOk = () => {
    const { store, form } = this.props
    const { submitFinishTask } = store
    const fieldValue = form.getFieldsValue()

    if (!fieldValue.remark) {
      return message.warning('请填写备注')
    }

    submitFinishTask(fieldValue)
  }

  render() {
    const {
      store,
      form: { getFieldDecorator }
    } = this.props

    const { confirmTaskModalVisible, setStoreData, currentTask } = store
    const { nick, remind_name } = currentTask

    return (
      <Modal
        title="确认完成任务"
        visible={confirmTaskModalVisible}
        onOk={this.handleOk}
        onCancel={() =>
          setStoreData([{ type: 'confirmTaskModalVisible', value: false }])
        }
      >
        <Form>
          <FormItem label="客户名" {...formItemLayout}>
            {nick}
          </FormItem>
          <FormItem label="任务类型" {...formItemLayout}>
            {remind_name}
          </FormItem>
          <FormItem label="内容" {...formItemLayout}>
            {dGet(currentTask, 'task_record.remark')}
          </FormItem>
          <FormItem label="完成备注" {...formItemLayout}>
            {getFieldDecorator('remark')(
              <TextArea rows={3} style={{ width: 400 }} />
            )}
          </FormItem>
        </Form>
      </Modal>
    )
  }
}

export default ConfirmTaskModal
